import config from './config.js'

export default {

  // bestehende tabellen auflisten
  listTables(start,count,sort = 'tableId') {
    return fetch(config.baseUrl + 'rest/tables/schemas?start=' + start + '&count=' + count + '&sort=' + encodeURIComponent(sort)).then(resp => resp.json());
  },

  // einzelnes tabellen scheman laden
  loadTableSchema(tableId) {
    return fetch(config.baseUrl + 'rest/tables/schemas/' + encodeURIComponent(tableId)).then(resp => resp.json());
  },

  // tabellen scheman speichern
  saveTableSchema(data) {
    return fetch(config.baseUrl + 'rest/tables/schemas/', { method: 'POST', body: JSON.stringify(data) }).then(resp => resp.json());
  },

  // tabellen scheman speichern
  dropTableSchema(tableId,withSchema) {
    return fetch(config.baseUrl + 'rest/tables/schemas/' + (withSchema ? '?deleteSchema=1' : ''), { method: 'DELETE' }).then(resp => resp.json());
  },

  // datenabfrage aus einer tabelle
  queryTableData(tableId,start,count,filter,sort) {
    var url = config.baseUrl + 'rest/tables/data/' + encodeURIComponent(tableId) + '?start=' + start + '&count=' + count;
    if (filter) {
      url += '&filter=' + encodeURIComponent(JSON.stringify(filter));
    }

    if (sort) {
      url += '&sort=' + encodeURIComponent(sort);
    }

    return fetch(url).then(resp => resp.json());
  },

  // löscht gewünschte zeilen
  deleteTableRows(tableId,filter,force) {
    var url = config.baseUrl + 'rest/tables/data/' + encodeURIComponent(tableId);
    if (filter) {
      url += '&filter=' + encodeURIComponent(JSON.stringify(filter));
    }
    if (force) {
      url += '&force=1';
    }
    return fetch(url,{method:'DELETE'}).then(resp => resp.json());
  },

  // neue daten in einer tabelle speichern
  saveTableData(tableId,data) {
    var url = config.baseUrl + 'rest/tables/data/' + encodeURIComponent(tableId);

    return fetch(url,{method: 'POST',body: JSON.stringify(data)}).then(resp => resp.json());
  },

  // neue daten in einer tabelle speichern
  loadTableRow(tableId,data,rid) {
    var url = config.baseUrl + 'rest/tables/data/' + encodeURIComponent(tableId) + '/' + encodeURIComponent(rid);

    return fetch(url).then(resp => resp.json());
  },

  // create an table export (excel for example)
  exportTableData(tableId,profile,name) {
    var url = config.baseUrl + 'rest/tables/export/' + encodeURIComponent(tableId) + '/' + encodeURIComponent(profile);

    if (name) url += '&name=' + encodeURIComponent(name);

    return fetch(url);
  },

  // import data, (append or replace)
  importTableData(tableId,profile,data,replace) {
    var url = config.baseUrl + 'rest/tables/import/' + encodeURIComponent(tableId) + '/' + encodeURIComponent(profile);

    if (replace) url += "&replace=1";

    return fetch(url,{method: 'POST', body: data}).then(resp => resp.json());
  },

  listTableSyncInfos(tableId) {
    var url = config.baseUrl + 'rest/tables/sync/' + encodeURIComponent(tableId);

    return fetch(url).then(resp => resp.json());
  },

  saveTableSyncInfo(tableId,syncinfo) {
    var url = config.baseUrl + 'rest/tables/sync/' + encodeURIComponent(tableId);

    return fetch(url,{
      method: 'POST',
      body: JSON.stringify(syncinfo),
      credentials: 'include'
    });
  },

  deleteTableSyncInfo(tableId,syncId) {
    var url = config.baseUrl + 'rest/tables/sync/' + encodeURIComponent(tableId) + '/' + encodeURIComponent(syncId);

    return fetch(url,{method:'DELETE'}).then(resp => resp.json());
  },

  startTableSync(tableId,syncId) {
    var url = config.baseUrl + 'rest/tables/sync/' + encodeURIComponent(tableId) + '/' + encodeURIComponent(syncId);

    return fetch(url).then(resp => resp.json());    
  },

  startRAGIndex(tableId) {
    var url = config.baseUrl + 'rest/tables/rag/index/' + encodeURIComponent(tableId);
    return fetch(url,{
      credentials: 'include'
    }).then(resp => resp.json());
  }
}
